// Centralized color definitions for utility types
const utilityColors = {
  afloeb: 'rgb(140, 81, 10)',
  anden: 'rgb(0, 230, 200)',
  el: 'rgb(215, 48, 39)',
  gas: 'rgb(255, 192, 0)',
  olie: 'rgb(0, 0, 0)',
  telekommunikation: 'rgb(104,187,31)',
  termisk: 'rgb(217, 87, 249)',
  vand: 'rgb(0, 112, 255)',
  informationsressource: 'rgb(147,245,191)',
  foreringsror: 'rgb(245, 162, 122)',
  error: 'rgb(255, 0, 0)',
  default: '#888888',
};

const interesseomraadeColors = {
  default: '#bb8900',
};

export const anmodningStatusColors = {
  'Gennemført': '#0080ff',
  'Hentet': '#a6d623',
  'Mangler Manuel Håndtering': '#FFA500',
  'Håndteret Manuelt': '#0080ff',
  'Udtaget til paavisning': '#ce0303',
};

export const fillDefault = {
  id: "fillDefault",
  type: "fill",
  source: "unknown",
  layout: {},
  paint: {
    "fill-color": "#0080ff",
    "fill-opacity": 0.5,
  },
};

export const otherId = "Manuel håndtering";
export const other_fill = {
  id: otherId,
  type: "fill",
  source: otherId,
  layout: {},
  paint: {
    "fill-color": [
      'case',
      ['==', ['get', 'is_manuel', ['get', 'config']], true],
      utilityColors.error,
      utilityColors.default
    ],
    "fill-opacity": 0.3,
  },
};

export const interesseomraadeId = "interesseomraade";
export const interesseomraadeLayer = {
  id: interesseomraadeId,
  type: "fill",
  source: interesseomraadeId,
  layout: {},
  paint: {
    "fill-color": interesseomraadeColors.default,
    "fill-opacity": 0.3,
  },
};

export const anmodning_id = "anmodning";
export const anmodning_fill = {
  id: anmodning_id,
  type: "fill",
  source: anmodning_id,
  layout: {},
  paint: {
    "fill-color": [
    'match',
      ['get', 'anmod_status'],
      'Gennemført', anmodningStatusColors['Gennemført'],
      'Hentet', anmodningStatusColors['Hentet'],
      'Mangler Manuel Håndtering', anmodningStatusColors['Mangler Manuel Håndtering'],
      'Håndteret Manuelt', anmodningStatusColors['Håndteret Manuelt'],
      'Udtaget til paavisning', anmodningStatusColors['Udtaget til paavisning'],
      utilityColors.default
    ],
    "fill-opacity": 0.5,
  },
};

export const layerLedningId = "ledning";
export const layerLedning = {
  id: layerLedningId,
  type: "line",
  source: layerLedningId,
  layout: {},
  paint: {
    "line-color": [
      'case',
      ['!=', ['get', 'error_msg'], null],
      utilityColors.error,
      [
        'match',
        ['get', 'ler:memberType', ['get', 'translated_properties']],
        'ler:Afloebsledning', utilityColors.afloeb,
        'ler:AndenLedning', utilityColors.anden,
        'ler:Elledning', utilityColors.el,
        'ler:Foeringsroer', utilityColors.foreringsror,
        'ler:Gasledning', utilityColors.gas,
        'ler:Olieledning', utilityColors.olie,
        'ler:Telekommunikationsledning', utilityColors.telekommunikation,
        'ler:TermiskLedning', utilityColors.termisk,
        'ler:Vandledning', utilityColors.vand,
        'ler:Informationsressource', utilityColors.informationsressource,
        utilityColors.default
      ]
    ],
    "line-width": [
      'case',
      ['!=', ['get', 'error_msg'], null],
      6,
      3
    ]
  },
};

export const layerKomponentId = "komponent";
export const layerKomponentCircle = {
  id: layerKomponentId,
  type: "circle",
  source: layerKomponentId,
  layout: {},
  paint: {
    "circle-color": [
      'case',
      ['!=', ['get', 'error_msg'], null],
      utilityColors.error,
      [
        'match',
        ['get', 'ler:memberType', ['get', 'translated_properties']],
        'ler:Afloebskomponent', utilityColors.afloeb,
        'ler:Andenkomponent', utilityColors.anden,
        'ler:Elkomponent', utilityColors.el,
        'ler:Gaskomponent', utilityColors.gas,
        'ler:Oliekomponent', utilityColors.olie,
        'ler:Telekommunikationskomponent', utilityColors.telekommunikation,
        'ler:TermiskKomponent', utilityColors.termisk,
        'ler:Vandkomponent', utilityColors.vand,
        'ler:Informationsressource', utilityColors.informationsressource,
        utilityColors.default
      ]
    ],
    "circle-radius": [
      'case',
      ['!=', ['get', 'error_msg'], null],
      8,
      5
    ],
    "circle-stroke-width": 1,
    "circle-stroke-color": "#000000"
  },
};

export const layerKomponentFillId = "komponenter - flade";
export const layerKomponentFill = {
  id: layerKomponentFillId,
  type: "fill",
  source: layerKomponentFillId,
  layout: {},
  paint: {
    "fill-color": [
      'case',
      ['!=', ['get', 'error_msg'], null],
      utilityColors.error,
      [
        'match',
        ['get', 'ler:memberType', ['get', 'translated_properties']],
        'ler:AfloebsKomponent', utilityColors.afloeb,
        'ler:AndenKomponent', utilityColors.anden,
        'ler:ElKomponent', utilityColors.el,
        'ler:GasKomponent', utilityColors.gas,
        'ler:OlieKomponent', utilityColors.olie,
        'ler:TelekommunikationsKomponent', utilityColors.telekommunikation,
        'ler:TermiskKomponent', utilityColors.termisk,
        'ler:Vandkomponent', utilityColors.vand,
        'ler:Informationsressource', utilityColors.informationsressource,
        utilityColors.default
      ]
    ],
    "fill-opacity": 0.5,
  },
};
  